import { nanoid } from 'nanoid';

// {
//   id: nanoid(),
//   img: '',
//   title: '',
//   info: '',
//   info2: '',
//   url: '',
//   repo: '',
// },

const advancedJSData = [
  {
    id: nanoid(),
    img: 'basicJS_bookmark-keeper.png',
    title: 'Bookmark Keeper',
    info: 'A simple and intuitive way to manage your web bookmarks. It features a user-friendly interface, enabling users to easily add, delete, and access their favorite websites.',
    info2: '',
    url: 'https://shcoobz.github.io/advancedJS_bookmark-keeper/',
    repo: 'https://github.com/Shcoobz/advancedJS_bookmark-keeper/',
  },

  {
    id: nanoid(),
    img: 'basicJS_calculator.png',
    title: 'Calculator',
    info: 'A simple calculator interface for performing basic arithmetic operations. It features a user-friendly interface with buttons for numbers, operators, and a clear function',
    info2: '',
    url: 'https://shcoobz.github.io/advancedJS_calculator/',
    repo: 'https://github.com/Shcoobz/advancedJS_calculator/',
  },

  {
    id: nanoid(),
    img: 'advancedJS_country-fetching-app.png',
    title: 'Country fetching App',
    info: 'The Country Fetching App is a versatile web application that provides users with easy access to comprehensive information about countries worldwide. With features like dynamic search, sorting, and favoriting countries, it offers a seamless user experience for exploring diverse international data.',
    info2: '',
    url: 'https://shcoobz.github.io/advancedJS_country-fetching-app/',
    repo: 'https://github.com/Shcoobz/advancedJS_country-fetching-app',
  },

  {
    id: nanoid(),
    img: 'advancedJS_country-fetching-app.png',
    title: 'Country fetching App with Database',
    info: 'This project is an extension of the Country fetching App where favorites are saved in a Mongo database instead.',
    info2:
      'Please note that this project includes a backend component that requires server-side processing, which Github Pages does not offer',
    url: '',
    repo: 'https://github.com/Shcoobz/advancedJS_country-fetching-app-with-database',
  },

  {
    id: nanoid(),
    img: 'basicJS_custom-countdown.png',
    title: 'Countdown',
    info: 'Allows for the creation and customization of countdowns for various events or occasions. It features a user-friendly interface and essential functionalities for managing countdowns.',
    info2: '',
    url: 'https://shcoobz.github.io/advancedJS_custom-countdown/',
    repo: 'https://github.com/Shcoobz/advancedJS_custom-countdown/',
  },

  {
    id: nanoid(),
    img: 'basicJS_figma_splash-page.png',
    title: 'Figma: Splash Page',
    info: 'A visually engaging splash page for showcasing applications. It features a clean, user-friendly interface inspired by a professional design created in Figma, emphasizing ease of navigation and aesthetic appeal.',
    info2: '',
    url: 'https://shcoobz.github.io/advancedJS_figma_splash-page/',
    repo: 'https://github.com/Shcoobz/advancedJS_figma_splash-page/',
  },

  {
    id: nanoid(),
    img: 'basicJS_form-validation.png',
    title: 'Form Validation',
    info: 'A sleek and user-friendly interface for users to sign up with their details. It features comprehensive input validation to ensure that all user-submitted data meets specific criteria before being processed.',
    info2: '',
    url: 'https://shcoobz.github.io/advancedJS_form-validation/',
    repo: 'https://github.com/Shcoobz/advancedJS_form-validation/',
  },

  {
    id: nanoid(),
    img: 'basicJS_infinity-scroll.png',
    title: 'Infinity Scroll',
    info: 'This web application uses the Unsplash API to provide an infinite scroll of random images. As the user scrolls down, it continuously loads more images for an endless visual experience.',
    info2: '',
    url: 'https://shcoobz.github.io/advancedJS_infinite-scroll/',
    repo: 'https://github.com/Shcoobz/advancedJS_infinite-scroll',
  },

  {
    id: nanoid(),
    img: 'basicJS_joke-teller.png',
    title: 'Joke Teller',
    info: 'A fun and interactive way to hear random jokes, especially focusing on programming humor. It features a simple, user-friendly interface that allows users to listen to a joke with just a click of a button.',
    info2: '',
    url: 'https://shcoobz.github.io/advancedJS_joke-teller/',
    repo: 'https://github.com/Shcoobz/advancedJS_joke-teller/',
  },

  {
    id: nanoid(),
    img: 'basicJS_light-dark-mode.png',
    title: 'Light/Dark Mode',
    info: 'A dynamic theme toggling feature that allows users to switch between light and dark modes with ease. It features a user-friendly interface and seamless integration into any web application.',
    info2: '',
    url: 'https://shcoobz.github.io/advancedJS_light-dark-mode/',
    repo: 'https://github.com/Shcoobz/advancedJS_light-dark-mode/',
  },

  {
    id: nanoid(),
    img: 'basicJS_math-sprint-game.png',
    title: 'Math Sprint Game',
    info: 'A dynamic environment for users to practice their math skills under time pressure. It features a user-friendly interface, adjustable difficulty levels, and immediate feedback on performance.',
    info2: '',
    url: 'https://shcoobz.github.io/advancedJS_math-sprint-game/',
    repo: 'https://github.com/Shcoobz/advancedJS_math-sprint-game/',
  },

  {
    id: nanoid(),
    img: 'basicJS_music-player.png',
    title: 'Music Player',
    info: 'A simple and intuitive interface for playing music tracks. It features a minimalist design, easy navigation between songs, and a responsive layout for different screen sizes.',
    info2: '',
    url: 'https://shcoobz.github.io/advancedJS_music-player/',
    repo: 'https://github.com/Shcoobz/advancedJS_music-player/',
  },

  {
    id: nanoid(),
    img: 'basicJS_nasa-apod.png',
    title: 'NASA APOD',
    info: "An engaging way to explore the cosmos through daily images and videos from NASA's collection. It features a user-friendly interface that allows astronomy enthusiasts to discover and save their favorite celestial phenomena.",
    info2: '',
    url: 'https://shcoobz.github.io/advancedJS_nasa-apod/',
    repo: 'https://github.com/Shcoobz/advancedJS_nasa-apod/',
  },

  {
    id: nanoid(),
    img: 'basicJS_navigation-nation.png',
    title: 'Navigation Nation',
    info: "An innovative web template that enhances the user interface with a stylish, animated navigation menu. It showcases dynamic animations for menu items and a full-page overlay, providing a modern and engaging user experience. Perfect for web developers looking to elevate their site's aesthetic and interactivity.",
    info2: '',
    url: 'https://shcoobz.github.io/advancedJS_navigation-nation/',
    repo: 'https://github.com/Shcoobz/advancedJS_navigation-nation/',
  },

  {
    id: nanoid(),
    img: 'basicJS_picture-in-picture.png',
    title: 'Picture in picture',
    info: 'This web application is an interactive tool designed to create a user-friendly interface where users can play a video in Picture in Picture mode, allowing them to watch video content while interacting with other applications or websites.',
    info2: '',
    url: 'https://shcoobz.github.io/advancedJS_picture-in-picture/',
    repo: 'https://github.com/Shcoobz/advancedJS_picture-in-picture',
  },

  {
    id: nanoid(),
    img: 'basicJS_ping-pong.png',
    title: 'Ping Pong',
    info: 'A classic arcade-style Ping Pong game playable on both desktop and mobile devices. It features a simple, user-friendly interface that allows players to control paddles using mouse movements, offering a fun and engaging experience for players of all ages.',
    info2: '',
    url: 'https://shcoobz.github.io/advancedJS_ping-pong/',
    repo: 'https://github.com/Shcoobz/advancedJS_ping-pong/',
  },

  {
    id: nanoid(),
    img: 'advancedJS_pizzeria-menu.png',
    title: 'Pizzeria App',
    info: 'The Pizza Order system is a streamlined solution for placing pizza orders, offering a user-friendly interface to select and customize pizzas with ease.',
    info2:
      'Please note that this project includes a backend component that requires server-side processing, which Github Pages does not offer.',
    url: '',
    repo: 'https://github.com/Shcoobz/advancedJS_pizza-order-prototype',
  },

  {
    id: nanoid(),
    img: 'advancedJS_pokemon-battle.png',
    title: 'Pokemon Battle',
    info: 'This application allows you to embark on exciting Pokémon battles. Choose your location, select a starter Pokémon, and engage in battles. Win to catch the defeated Pokémon or try again if you lose.',
    info2: '',
    url: 'https://shcoobz.github.io/advancedJS_pokemon-battle/ ',
    repo: 'https://github.com/Shcoobz/advancedJS_pokemon-battle',
  },

  {
    id: nanoid(),
    img: 'basicJS_quote-generator.png',
    title: 'Quote Generator',
    info: 'This was one of my first projects. It is a single-page web application that retrieves random quotes from an API and allows users to share them on Twitter.',
    info2: '',
    url: 'https://shcoobz.github.io/advancedJS_quote-generator/',
    repo: 'https://github.com/Shcoobz/advancedJS_quote-generator',
  },

  {
    id: nanoid(),
    img: 'basicJS_spock-rock-game.png',
    title: 'Spock Rock Game',
    info: 'Brings a fun and interactive twist to the classic Rock Paper Scissors game by incorporating two additional elements: Lizard and Spock. It features a simple, user-friendly interface, enabling players to easily select their move and instantly see the outcome of the match against the computer.',
    info2: '',
    url: 'https://shcoobz.github.io/advancedJS_spock-rock-game/',
    repo: 'https://github.com/Shcoobz/advancedJS_spock-rock-game/',
  },

  {
    id: nanoid(),
    img: 'basicJS_tailwind_animated-template.png',
    title: 'Tailwind: Animated Template',
    info: 'A dynamic and visually engaging web template designed to provide an immersive user experience through the use of animations and transitions. It features a user-friendly interface, seamless navigation, and interactive elements that bring content to life.',
    info2: '',
    url: 'https://shcoobz.github.io/advancedJS_tailwind_animated-template/',
    repo: 'https://github.com/Shcoobz/advancedJS_tailwind_animated-template/',
  },

  {
    id: nanoid(),
    img: 'advancedJS_tic-tac-toe.png',
    title: 'Tic Tac Toe',
    info: 'This application allows you to embark on exciting Pokémon battles. Choose your location, select a starter Pokémon, and engage in battles. Win to catch the defeated Pokémon or try again if you lose.',
    info2: '',
    url: 'https://shcoobz.github.io/advancedJS_tic-tac-toe/',
    repo: 'https://github.com/Shcoobz/advancedJS_tic-tac-toe',
  },

  {
    id: nanoid(),
    img: 'basicJS_video-player.png',
    title: 'Video Player',
    info: 'A custom, intuitive video player interface for web applications. It features a user-friendly control panel with play/pause, volume adjustment, playback speed control, progress tracking, and fullscreen capabilities.',
    info2: '',
    url: 'https://shcoobz.github.io/advancedJS_video-player/',
    repo: 'https://github.com/Shcoobz/advancedJS_video-player/',
  },
];

export default advancedJSData;
